export class SaveInventoryGigotProductDto {

    public name : string;

    public stock : number;

    public imageUrl : any;

    public height: number;

    public width: number;

    public length: number;

    public inPiqueo: boolean;

    public isGigotProduct: boolean;

    public voucher: boolean;

    public code: string;
}
